// Mock data pour le site Perinature

export const companyInfo = {
  name: "Perinature",
  tagline: "CONCEPTION - CRÉATION - ENTRETIEN DE TOUS VOS EXTÉRIEURS",
  description: "Situé dans le Périgord Noir, à 25 kilomètres de Sarlat-la Canéda, Perinature est une entreprise du paysage créée par ROQUE Patrick depuis 2001. Nous vous proposons différents services. De sa conception, à l'aménagement de votre extérieur jusqu'à son entretien, nous vous proposons de s'occuper de votre extérieur de A à Z. Par notre expérience, nous nous engageons à vous fournir un travail de qualité, dans le respect de l'environnement et de vos besoins.",
  address: "1, Impasse du Château 24170 Monplaisant",
  phone: "06 01 64 25 76",
  email: "perinature24@gmail.com",
  since: "2001",
  founder: "ROQUE Patrick"
};

export const testimonials = [
  {
    id: 1,
    rating: 5,
    text: "Entreprise très sérieuse, j'ai fait planter 4 arbres et une allée de cyprès, rien à redire ! Je peux recommander sans problème !",
    date: "2024"
  },
  {
    id: 2,
    rating: 5,
    text: "Stéphane et Patrick sont très professionnels, disponibles et leur travail est soigné, je recommande",
    date: "2024"
  },
  {
    id: 3,
    rating: 5,
    text: "Travail impeccable et respect des délais. L'équipe a transformé notre jardin en un véritable havre de paix. Nous sommes ravis du résultat !",
    date: "2024"
  },
  {
    id: 4,
    rating: 5,
    text: "Professionnalisme et écoute. Patrick a su comprendre nos besoins et nous conseiller efficacement. Le résultat dépasse nos attentes.",
    date: "2023"
  }
];

export const services = {
  conception: {
    title: "Conception",
    description: "De la première ébauche de votre projet jusqu'à sa réalisation, nous vous accompagnons dans toutes les étapes de conception de votre espace extérieur.",
    features: [
      "Étude personnalisée de votre terrain",
      "Plans d'aménagement détaillés",
      "Conseil en choix des végétaux adaptés",
      "Simulation 3D de votre projet",
      "Devis détaillé et transparent",
      "Respect de votre budget et de vos envies"
    ],
    details: "Notre expertise nous permet de concevoir des espaces verts qui s'intègrent harmonieusement à votre environnement, tout en respectant les spécificités du Périgord Noir. Nous prenons en compte l'exposition, le type de sol, le climat et vos préférences esthétiques pour créer un jardin qui vous ressemble."
  },
  creation: {
    title: "Création",
    description: "Nous concrétisons vos projets d'aménagement paysager avec savoir-faire et passion. De la préparation du terrain à la plantation finale, chaque étape est réalisée avec soin.",
    features: [
      "Terrassement et nivellement",
      "Création d'allées et terrasses",
      "Plantation d'arbres et arbustes",
      "Installation de systèmes d'arrosage",
      "Pose de clôtures et portails",
      "Aménagement de massifs et rocailles"
    ],
    details: "Forte de plus de 20 ans d'expérience, notre équipe maîtrise toutes les techniques d'aménagement paysager. Nous utilisons des matériaux de qualité et sélectionnons des végétaux adaptés au climat du Périgord pour garantir la pérennité de vos aménagements."
  },
  entretien: {
    title: "Entretien",
    description: "Un jardin bien entretenu est un jardin qui reste beau toute l'année. Nous proposons des formules d'entretien régulier adaptées à vos besoins et à votre budget.",
    features: [
      "Tonte et scarification de pelouse",
      "Taille de haies et arbustes",
      "Désherbage et débroussaillage",
      "Élagage et abattage d'arbres",
      "Entretien de massifs",
      "Nettoyage de terrasses et allées"
    ],
    details: "Votre jardin mérite un entretien professionnel pour rester magnifique en toutes saisons. Nous intervenons régulièrement selon un calendrier établi ensemble.",
    fiscalAdvantage: {
      title: "Avantages Fiscaux pour l'Entretien de Jardin",
      description: "Perinature travaille en partenariat avec une coopérative de services à la personne, vous permettant de bénéficier d'avantages fiscaux importants pour l'entretien de votre jardin.",
      benefits: [
        {
          title: "50% de Crédit d'Impôt Particuliers",
          description: "Si vous êtes un particulier, vous pouvez bénéficier d'un crédit d'impôt de 50% sur le montant des prestations d'entretien de jardin. Cette réduction s'applique directement sur votre impôt sur le revenu."
        },
        {
          title: "Avance Immédiate",
          description: "Vous ne payez que 50% du montant total de la prestation au moment de la facturation. Les 50% restants sont directement pris en charge par le crédit d'impôt. Pas besoin d'attendre l'année suivante pour bénéficier de l'avantage fiscal."
        },
        {
          title: "Crédit d'Impôt Entreprise",
          description: "Les entreprises peuvent bénéficier d'un crédit d'impôt de 25% sur l'entretien des espaces verts au domicile du dirigeant ou de leurs employés. Ces dépenses sont prises en charge par l'entreprise, permettant ainsi d'améliorer le cadre de vie de vos collaborateurs tout en bénéficiant d'un avantage fiscal."
        }
      ],
      howItWorks: {
        title: "Comment ça fonctionne ?",
        steps: [
          "Demandez votre devis gratuit pour l'entretien régulier de votre jardin",
          "Nous établissons une convention avec la coopérative partenaire",
          "Vous recevez une facture avec le montant après déduction de 50%",
          "Vous déclarez les dépenses et le crédit d'impôt est automatiquement appliqué",
          "Pour l'avance immédiate : vous ne payez que 50% immédiatement"
        ]
      }
    }
  }
};

export const galleryImages = [
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/95fufzrj_DSC_0087.jpg",
    title: "Pelouse verdoyante",
    category: "home",
    description: "Entretien de pelouse et plantation d'arbres"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/gmm5efbn_2011-08-09_19-28-30_894-EDIT.jpg",
    title: "Aménagement avec murets en pierre",
    category: "home",
    description: "Création de massifs et murets décoratifs"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/icizjyft_image%20%281%29.jpg",
    title: "Plan d'aménagement paysager",
    category: "conception",
    description: "Conception détaillée avec allées et espaces verts"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/1fwz3e9p_image%20%282%29.jpg",
    title: "Conception de jardin résidentiel",
    category: "conception",
    description: "Plan complet avec piscine et terrasses"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/gfwngfkp_image.jpg",
    title: "Projet d'aménagement extérieur",
    category: "conception",
    description: "Vue 3D du jardin avec bassin et végétation"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/16qyxl7c_Projet%20Vignal%201.jpg",
    title: "Projet Vignal",
    category: "conception",
    description: "Conception complète d'espace extérieur"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/ft9gfblg_PXL_20240221_153404086.MP.jpg",
    title: "Aménagement d'entrée avec graviers",
    category: "creation",
    description: "Création d'allée avec plantations et bordures"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/0u86k8pj_PXL_20240626_055719424.MP.jpg",
    title: "Construction de terrasse en bois",
    category: "creation",
    description: "Terrasse sur pilotis avec garde-corps"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/et7oedhd_PXL_20240925_162331390.MP.jpg",
    title: "Allée en gravier stabilisé",
    category: "creation",
    description: "Création d'allée avec plantations latérales"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/mtt17ypr_PXL_20250521_153908362.MP.jpg",
    title: "Aménagement paysager commercial",
    category: "creation",
    description: "Espaces verts pour bâtiment professionnel"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/i5wjib2j_PXL_20250429_100042543.MP.jpg",
    title: "Terrasse avec vue panoramique",
    category: "creation",
    description: "Aménagement de terrasse avec végétation en pots"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/do3eduue_PXL_20260224_161558501.MP.jpg",
    title: "Élagage professionnel",
    category: "entretien",
    description: "Taille et élagage d'arbres en hauteur"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/jc36df9h_avant_apres.jpg",
    title: "Transformation de jardin",
    category: "entretien",
    description: "Résultat avant/après d'un entretien complet"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_perinature-clone/artifacts/nepwc38q_PXL_20251118_141331624.MP.jpg",
    title: "Entretien de pelouse et haies",
    category: "entretien",
    description: "Tonte et taille de haies avec camion professionnel"
  }
];